import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment } from '../../shared/models/environment';
import { ApiConfig, RequestParam } from '../../shared/models/app';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService extends HttpService {
  /*********************Properties*********************/
  protected get apiConfig(): ApiConfig {
    return Environment.getInstance().apiConfig;
  }
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(protected http: HttpClient) {
    super(http);
  }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/

  protected serviceUrl(...suffix) {
    return this.flatten(suffix).join('');
  }

  flatten(suffix): Array<any> {
      let result= [];
      suffix.forEach((value) => {
        if (Array.isArray(value)) {
          this.flatten(value);
        } else {
          result.push(value);
        }
      });
      return result;
  }

  protected getRequestParams(params: RequestParam[]): string {
    let queryString = '';

    params.forEach(param => {
      queryString += queryString ? '&' : '?';
      queryString += param.key + '=' + param.value;
    });

    return queryString;
  }

  /*********************Service Methods*********************/
}
